<template>
  <div>
    <page-content>
      <ntm-block title="TV CODE" :init-collapse="false" :collapsable="false">
        <template #options>
          <span class="mb-0 font-size-h4 font-weight-bold">
            {{ formattedTvCode }}
          </span>

          <button
            @click="generateUserTvCode"
            class="btn btn-sm"
            :class="{
              'btn-warning': settings.tvCode,
              'btn-success': !settings.tvCode
            }"
          >
            <i class="fa fa-undo"></i>
          </button>
        </template>
      </ntm-block>
    </page-content>
  </div>
</template>

<script>
import SettingsService from '@/services/settings.service'

export default {
  name: 'TvApp',

  data () {
    return {
      settings: {
        tvCode: null
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    SettingsService.index().then((response) => {
      next(vm => vm.setData(response.data))
    })
  },
  computed: {
    formattedTvCode () {
      if (!this.settings.tvCode) return ''
      return this.settings.tvCode
        .toString()
        .replace(/(?=(?:.{3})*$)/g, ' ')
    }
  },

  methods: {
    setData (data) {
      this.settings = data
    },
    generateUserTvCode () {
      SettingsService.generateUserTvCode().then((res) => {
        this.settings.tvCode = res.data.toString()
      })
    }
  }
}
</script>
